<p-breadcrumb [model]="items"></p-breadcrumb>